export const iconFontAwesomeTimeCalendarXmark = (
	<i className="fa-solid fa-calendar-xmark"></i>
);
